import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@hotelise/ui';
import { ContractChannelSplit } from 'interfaces/contracts';

const CHANNEL_LABELS: Record<keyof ContractChannelSplit, string> = {
  airbnb: 'Airbnb',
  booking: 'Booking',
  direct: 'Direct',
  vrbo: 'Vrbo',
};

interface PayoutSummaryProps {
  channelSplit?: ContractChannelSplit;
}

const PayoutSummary = ({ channelSplit }: PayoutSummaryProps): JSX.Element => {
  if (!channelSplit) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  const entries = Object.entries(channelSplit) as [keyof ContractChannelSplit, number][];
  const ownerChannels = entries.filter(([, v]) => v === 0);

  // All go to Hotelise (all values === 1)
  if (ownerChannels.length === 0) {
    return (
      <span className="text-xs text-muted-foreground">Managed</span>
    );
  }

  // All go to Owner (all values === 0)
  if (ownerChannels.length === entries.length) {
    return (
      <Badge variant="destructive" className="text-[11px]">
        Owner pays all
      </Badge>
    );
  }

  // Mixed: show owner-paid channels
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex flex-wrap gap-1">
            {ownerChannels.map(([ch]) => (
              <Badge key={ch} variant="destructive" className="text-[11px] px-1.5 py-0">
                {CHANNEL_LABELS[ch]}
              </Badge>
            ))}
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          Owner-paid channels. Rest managed by Hotelise.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default PayoutSummary;
